import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { drRepository, drDataContainer, AppUser, drPluginContent, crossMsg } from '@robisoft/cross-library';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-opengolf',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit  {
  @Input('name') name: string;
  @Input('mytoken') mytoken: string;
  @Input('store') store: string;
  @Input('appstore') appstore: AppUser; // utente associato a ?store=opengolf
  @Input('curruser') curruser: AppUser; // utente corrente
  @Input('curruser2') curruser2: AppUser; // utente con cui si sta chattando
  @Input('currpage') currpage: drRepository;
  @Input('currlang') currlang: string;
  @Input('content') content: drPluginContent;
  @Input('storage') storage: Map<string, any>;
  // @Input('websiteStypes') wss: drWebSiteStyle;
  @Output() onMessage = new EventEmitter<crossMsg>();
  /*
  @Input('name') name: string;
  @Input('myToken') myToken: string;
  @Input('store') store: string;
  @Input('currUser') curruser: AppUser;
  @Input('currUser2') currUser2: AppUser;
  @Input('currPage') currPage: drRepository;
  @Input('currLang') currLang: string;
  @Input('content') content: drPluginContent;
  @Output() onMessage = new EventEmitter<crossMsg>();
  */
  initialized: BehaviorSubject<boolean>;
  locale: string;


  constructor(public translate: TranslateService) {
    this.initialized = new BehaviorSubject(false);
    
    

    const currLang = localStorage.getItem('currLang');
    if (!currLang) {
      localStorage.setItem('currLang', 'it');
      this.currlang = 'IT';
      // this.currLangChanged.next(this.currlang);
      translate.setDefaultLang('it');
      // robi dateAdapter.setLocale('it');
      this.locale = 'it-IT';
    } else {
      localStorage.setItem('currLang', currLang);
      this.currlang = currLang.toUpperCase();
//      this.currLangChanged.next(this.currLang);

      translate.setDefaultLang(currLang);
      // robi dateAdapter.setLocale(currLang);
      switch (currLang) {
        case 'IT':
          this.locale = 'it-IT';
          break;
        case 'EN':
          this.locale = 'en-EN';
          break;
        case 'DE':
          this.locale = 'de-DE';
          break;
      }
    }

  }

  async ngOnInit(): Promise<void> {
    
  }
  
  async ngOnChanges(): Promise<void> {
    // devo aspettare i dati, prima di richiamare l'init dei controlli
    this.initialized.next(true);
  }

}
